import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { RecommendationsModel } from 'lumen/routes/hotel/settings/recommendations';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

export default class HotelSettingsRecommendationsDynamicRateRangesRoute extends Route {
  @service declare access: Services['access'];
  @service declare featureToggle: Services['feature-toggle'];
  @service declare router: Services['router'];

  beforeModel(): void {
    const canAccessDynamicRateRanges =
      this.access.hasPricingAssistantDynamicRatePricingFeature &&
      this.featureToggle.hasFeatureToggle(
        FEATURE_TOGGLES.PRICING_MANAGER_DYNAMIC_RATE_RANGES,
      );

    if (!canAccessDynamicRateRanges) {
      this.router.transitionTo('hotel.settings.recommendations');
    }
  }

  model(): RecommendationsModel {
    return this.modelFor(
      'hotel.settings.recommendations',
    ) as RecommendationsModel;
  }
}
